import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

const template = `
<div class="mt-12 text-center max-w-160 ml-auto mr-auto">
    <h1 class="text-2xl text-rose-500">We're sorry, we couldn't find that page!</h1>
    <p class="text-lg mt-4">
        You can hit your browsers 'back' button to return from where you were, or
        <a routerLink="/" class="text-blue-700">navigate to the home page.</a>
    </p>.
`;

@Component({
  template: template,
  imports: [RouterLink],
})
export class PageNotFoundPage {}
